import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Portfolio } from "@/components/site/Portfolio";
import { Process } from "@/components/site/Process";
import { Technologies } from "@/components/site/Technologies";
import { WhyMe } from "@/components/site/WhyMe";
import { Testimonials } from "@/components/site/Testimonials";
import { About } from "@/components/site/About";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
    const lenisRef = useRef(null);

    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });
        lenisRef.current = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    const scrollTo = (target) => {
        lenisRef.current?.scrollTo(target, { offset: -70, duration: 1.4 });
    };

    return (
        <LanguageProvider>
            <div className="min-h-screen bg-void text-white overflow-x-clip" data-testid="app-root">
                <Navbar onNavigate={scrollTo} />
                <main>
                    <Hero onNavigate={scrollTo} />
                    <Marquee />
                    <Services />
                    <Portfolio />
                    <Process />
                    <Technologies />
                    <WhyMe />
                    <Testimonials />
                    <About />
                    <Contact />
                </main>
                <Footer onNavigate={scrollTo} />
                <Toaster theme="dark" position="bottom-right" />
            </div>
        </LanguageProvider>
    );
}

export default App;
